module.exports = __webpack_public_path__ + "img/cloud-services.ebbff9fb.jpg";